// export const backendUrl = "http://3.141.147.6:3000/api"; //staging
 export const backendUrl = "https://backend.talentsync.agency/api"; //production
// export const backendUrl = "http://localhost:5000/api"; //local